import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import { store } from "./store/";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment, { min } from "moment";

import AOS from "aos";
import "aos/dist/aos.css";

Vue.prototype.moment = moment;
library.add(fas);
library.add(far);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

axios.defaults.headers.common["Authorization"] = null;

axios.interceptors.response.use(
  function(response) {
    console.log(response);
    return response;
  },

  axios.interceptors.request.use(function(request) {
    console.log(request);
    return request;
  }),

  function(error) {
    if (error.response.status === 401) {
      store.dispatch("auth/signout");
    }

    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  created() {
    AOS.init({
      easing: "ease-in-out-back"
    });
  },
  render: h => h(App)
}).$mount("#app");
